export const WELCOME_GREETINGS_FR = [
  { text: 'Bonjour', emoji: '👋' },
  { text: 'Salut', emoji: '👋' },
  { text: 'Hello', emoji: '✨' },
  { text: 'Bienvenue', emoji: '✨' },
  { text: 'Prêt ?', emoji: '🚀' },
  { text: 'Go', emoji: '🚀' },
  { text: 'On y va ?', emoji: '🚀' },
  { text: 'Dis-moi', emoji: '💬' },
  { text: 'À vous', emoji: '💬' },
  { text: 'J’écoute', emoji: '👂' },
  { text: 'Présent', emoji: '👋' },
  { text: 'Allons-y', emoji: '🚀' },
  { text: 'Partant', emoji: '🚀' },
  { text: 'Prêt', emoji: '🚀' }
]

export function pickWelcomeGreeting(locale = 'fr', random = Math.random) {
  const variants = getWelcomeGreetingVariants(locale)
  const value = typeof random === 'function' ? Number(random()) : Math.random()
  const index = Math.max(0, Math.min(variants.length - 1, Math.floor(value * variants.length)))
  return variants[index]
}

function getWelcomeGreetingVariants(locale) {
  const normalized = String(locale || 'fr').toLowerCase()
  if (normalized.startsWith('fr')) return WELCOME_GREETINGS_FR
  return WELCOME_GREETINGS_FR
}
